import { useConfigStore } from "@/@core/stores/config";
//import { store } from "@/plugins/2.pinia";
import { useApiStore } from "@/stores/api";
import { ofetch } from "ofetch";
import { toast } from "vue3-toastify";

//console.log("$api register", useApiStore());

//let apiStore = useApiStore();

//let
//apiStore = useApiStore();

//console.log("$api register", apiStore);

//let baseURL = apiStore.baseURL ?? "https://statdbs.xyz/api";
let baseURL = "https://statdbs.xyz/api";

export function createApi(baseURL = "/api", token = null) {
    let api = ofetch.create({
        baseURL: baseURL,
        async onRequest({ options }) {
            const accessToken = useCookie("accessToken").value;
            if (accessToken)
                options.headers.append(
                    "Authorization",
                    `Bearer ${accessToken}`,
                );
        },
        async onResponseError({ request, options, response }) {
            console.log("onResponseError", response);
            let content = "";
            let message, errors;
            if ((message = response._data?.message)) {
                content += message + "\n\r";
            }
            if ((errors = response._data?.errors)) {
                content += JSON.stringify(errors);
            }
            toast(
                {
                    title: "Ошибка",
                    content,
                },
                {
                    autoClose: 2000,
                    type: "error",
                },
            );
        },
    });

    return api;
}

export function updateApi(url = "/api", token = null) {
    $api = createApi(url, token);

    toast("Сервер изменен на: " + url, {
        autoClose: 2000,
        type: "success",
    });
}

export function initApi(url = "/api", token = null) {
    $api = createApi(url, token);
}

export let $api = createApi(baseURL);
